<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex md12>
                        <slot name="info"></slot>
                    </v-flex>
                    <v-flex md6>
                        <v-layout row v-if="errors !== null">
                            <v-flex md12>
                                <div class="content-wrapper">
                                    <div class="error-block">
                                        <div class="title">Errors</div>
                                        <p v-html="errors"></p>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">{{ $t('formFleet.forms.name.name') }} <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    :label="$t('formFleet.forms.name.label')"
                                    v-model="form.name"
                                    :rules="rules.name"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row class="buttons">
                            <v-flex xs6>
                                <sp-button v-if="backButton" @click.native="goBack" :text="$t('formFleet.buttons.goBack')" small-icon icon="go-back" sp-class="go-back"></sp-button>
                            </v-flex>
                            <v-flex xs6 class="right text-xs-right">
                                <sp-button @click.native="validate" :text="$t('formFleet.buttons.save')" icon="download"></sp-button>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import FleetApi from '@/api/FleetApi'
import router from '@/router/routes'

const fleetApi = new FleetApi()

export default {
    name: 'FleetForm',
    components: {
        SpButton
    },
    async mounted () {
    },
    beforeUpdate () {
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        backButton: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            isDisabled: false,
            errors: null,
            fleets: [],
            valid: false,
            selected: null,
            rules: {
                name: [
                    v => !!v || this.$t('formFleet.forms.name.rules.required'),
                    v => (v.length && 3 <= v.trim().length && 100 >= v.trim().length) || 'Fleet name must be at least 3 and less than 100 characters',
                    v => (v === v.trim()) || 'Manufacturer cannot have leading or trailing spaces'
                ]
            }
        }
    },
    methods: {
        async getFleetList (parentId) {
            const response = await fleetApi.getFleetList({
                page: 1,
                perPage: 1000
            })
            return response.data.items
        },
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            let formData = {
                name: this.form.name
            }

            try {
                this.errors = null
                await this.handler(formData)
            } catch (e) {
                this.errors = e.message
            }
        },
        goBack () {
            router.push('/settings/fleets')
        }
    }
}
</script>

<style scoped lang="scss">
.v-form > .container {
    padding: 0px;
}
</style>
